import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './BingoCard.css'
import CryptoJS from 'crypto-js';
import api from '../api';
import LoadingOverlay from './LoadingOverlay';
import localforage from 'localforage';

const BingoCard = ({ cardNumber, calledNumbers, isWinner, winningNumbers }) => {
  const storedPatterns = localStorage.getItem('winningPattern');
  const winningPatterns = storedPatterns ? JSON.parse(storedPatterns) : ['any'];
  const winningPatternType = localStorage.getItem('winningPattern')
  const [lastWinningNumber, setLastWinningNumber] = useState(null);
  const [cards, setCards] = useState([]);
  const [B, setB] = useState([]);
  const [I, setI] = useState([]);
  const [N, setN] = useState([]);
  const [G, setG] = useState([]);
  const [O, setO] = useState([]);
  const [row1, setRow1] = useState([])
  const [row2, setRow2] = useState([])
  const [row3, setRow3] = useState([])
  const [row4, setRow4] = useState([])
  const [row5, setRow5] = useState([])
  const [diag1, setDiag1] = useState([])
  const [diag2, setDiag2] = useState([])
  const [corner, setCorner] = useState([])
  const [surr, setSurr] = useState([])
  const [loading, setLoading] = useState(true);

  const getApiUrl = () => {
    const hashedApiVersion = localStorage.getItem('apiVersion');
    if (hashedApiVersion) {
      const version2Hash = CryptoJS.SHA256('2').toString();
      if (hashedApiVersion === version2Hash) {
        return 'https://phoenix-bingo-2.onrender.com/api';
      }
    }
    return process.env.REACT_APP_API;
  };

  const API = getApiUrl();

  useEffect(() => {
    async function fetchCards() {
      try {
        // Try to get cards from localforage first
        const cachedCards = await localforage.getItem('bingoCards');
        
        if (cachedCards) {
          // If cards exist in cache, use them
          const foundCard = cachedCards.find((card) => card.paletteNumber == cardNumber);

          if (foundCard) {
            setCards(foundCard);
            setB(foundCard.numbers.B);
            setI(foundCard.numbers.I);
            setN(foundCard.numbers.N);
            setG(foundCard.numbers.G);
            setO(foundCard.numbers.O);
            setRow1([foundCard.numbers.B[0], foundCard.numbers.I[0], foundCard.numbers.N[0], foundCard.numbers.G[0], foundCard.numbers.O[0]]);
            setRow2([foundCard.numbers.B[1], foundCard.numbers.I[1], foundCard.numbers.N[1], foundCard.numbers.G[1], foundCard.numbers.O[1]]);
            setRow3([foundCard.numbers.B[2], foundCard.numbers.I[2], foundCard.numbers.G[2], foundCard.numbers.O[2]]);
            setRow4([foundCard.numbers.B[3], foundCard.numbers.I[3], foundCard.numbers.N[3], foundCard.numbers.G[3], foundCard.numbers.O[3]]);
            setRow5([foundCard.numbers.B[4], foundCard.numbers.I[4], foundCard.numbers.N[4], foundCard.numbers.G[4], foundCard.numbers.O[4]]);
            setDiag1([foundCard.numbers.B[0], foundCard.numbers.I[1], foundCard.numbers.G[3], foundCard.numbers.O[4]]);
            setDiag2([foundCard.numbers.O[0], foundCard.numbers.G[1], foundCard.numbers.I[3], foundCard.numbers.B[4]]);
            setCorner([foundCard.numbers.B[0], foundCard.numbers.B[4], foundCard.numbers.O[0], foundCard.numbers.O[4]]);
            setSurr([foundCard.numbers.I[1], foundCard.numbers.I[3], foundCard.numbers.G[1], foundCard.numbers.G[3]]);
            setLoading(false);
            return;
          }
        }

        // If cards not in cache or specific card not found, fetch from API
        const response = await api.get(`${API}/card/getCards`);
        const cards = await response;
        
        // Store cards in localforage
        await localforage.setItem('bingoCards', cards);

        const foundCard = cards.find((card) => card.paletteNumber == cardNumber);
        setCards(foundCard);
        setLoading(false); // Set loading to false after cards are fetched

        if (foundCard) {
          setB(foundCard.numbers.B);
          setI(foundCard.numbers.I);
          setN(foundCard.numbers.N);
          setG(foundCard.numbers.G);
          setO(foundCard.numbers.O);
          setRow1([foundCard.numbers.B[0], foundCard.numbers.I[0], foundCard.numbers.N[0], foundCard.numbers.G[0], foundCard.numbers.O[0]]);
          setRow2([foundCard.numbers.B[1], foundCard.numbers.I[1], foundCard.numbers.N[1], foundCard.numbers.G[1], foundCard.numbers.O[1]]);
          setRow3([foundCard.numbers.B[2], foundCard.numbers.I[2], foundCard.numbers.G[2], foundCard.numbers.O[2]]);
          setRow4([foundCard.numbers.B[3], foundCard.numbers.I[3], foundCard.numbers.N[3], foundCard.numbers.G[3], foundCard.numbers.O[3]]);
          setRow5([foundCard.numbers.B[4], foundCard.numbers.I[4], foundCard.numbers.N[4], foundCard.numbers.G[4], foundCard.numbers.O[4]]);
          setDiag1([foundCard.numbers.B[0], foundCard.numbers.I[1], foundCard.numbers.G[3], foundCard.numbers.O[4]]);
          setDiag2([foundCard.numbers.O[0], foundCard.numbers.G[1], foundCard.numbers.I[3], foundCard.numbers.B[4]]);

          setCorner([foundCard.numbers.B[0], foundCard.numbers.B[4], foundCard.numbers.O[0], foundCard.numbers.O[4]])
          setSurr([foundCard.numbers.I[1], foundCard.numbers.I[3], foundCard.numbers.G[1], foundCard.numbers.G[3]])
        } else {
          console.error('Card not found');
        }
      } catch (error) {
        console.error('Error fetching cards:', error);
      }
    }
    fetchCards();
  }, []);

  useEffect(() => {
    if (isWinner && winningNumbers && winningNumbers.length > 0) {
      const winningPattern = checkWinningPattern();
      const storedPatterns = localStorage.getItem('winningPattern');
      const winningPatterns = storedPatterns ? JSON.parse(storedPatterns) : ['any'];

      let allWinningPatterns = [];

      for (const patternType of winningPatterns) {
        let patternNumbers = [];
        
        switch(patternType) {
          case 'any':
            if (winningPattern.Bcolumn) {
              B.forEach(num => patternNumbers.push(`B${num}`));
            }
            if (winningPattern.Icolumn) {
              I.forEach(num => patternNumbers.push(`I${num}`));
            }
            if (winningPattern.Ncolumn) {
              N.forEach(num => {
                if (num !== 'FREE') patternNumbers.push(`N${num}`);
              });
            }
            if (winningPattern.Gcolumn) {
              G.forEach(num => patternNumbers.push(`G${num}`));
            }
            if (winningPattern.Ocolumn) {
              O.forEach(num => patternNumbers.push(`O${num}`));
            }
            if (winningPattern.firstRow) {
              patternNumbers.push(
                `B${row1[0]}`, `I${row1[1]}`, `N${row1[2]}`, `G${row1[3]}`, `O${row1[4]}`
              );
            }
            if (winningPattern.secondRow) {
              patternNumbers.push(
                `B${row2[0]}`, `I${row2[1]}`, `N${row2[2]}`, `G${row2[3]}`, `O${row2[4]}`
              );
            }
            if (winningPattern.thirdRow) {
              patternNumbers.push(
                `B${row3[0]}`, `I${row3[1]}`, `G${row3[2]}`, `O${row3[3]}`
              );
            }
            if (winningPattern.fourthRow) {
              patternNumbers.push(
                `B${row4[0]}`, `I${row4[1]}`, `N${row4[2]}`, `G${row4[3]}`, `O${row4[4]}`
              );
            }
            if (winningPattern.fifthRow) {
              patternNumbers.push(
                `B${row5[0]}`, `I${row5[1]}`, `N${row5[2]}`, `G${row5[3]}`, `O${row5[4]}`
              );
            }
            if (winningPattern.firstDiag) {
              patternNumbers.push(
                `B${diag1[0]}`, `I${diag1[1]}`, `G${diag1[2]}`, `O${diag1[3]}`
              );
            }
            if (winningPattern.secondDiag) {
              patternNumbers.push(
                `O${diag2[0]}`, `G${diag2[1]}`, `I${diag2[2]}`, `B${diag2[3]}`
              );
            }
            if (winningPattern.cornerPattern) {
              patternNumbers.push(
                `B${corner[0]}`, `B${corner[1]}`, `O${corner[2]}`, `O${corner[3]}`
              );
            }
            if (winningPattern.surrPattern) {
              patternNumbers.push(
                `I${surr[0]}`, `I${surr[1]}`, `G${surr[2]}`, `G${surr[3]}`
              );
            }
            break;
          case 'corners':
            if (winningPattern.cornerPattern) {
              let cornerNums = [
                `B${corner[0]}`, `B${corner[1]}`, `O${corner[2]}`, `O${corner[3]}`
              ];
              const winningCalledNumbers = calledNumbers.filter(num => cornerNums.includes(num));
              if (winningCalledNumbers.length === cornerNums.length) {
                const completionCallNumber = Math.max(...cornerNums.map(num => 
                  calledNumbers.indexOf(num)
                ));
                allWinningPatterns.push({
                  pattern: 'corners',
                  numbers: cornerNums,
                  lastCalledNumber: calledNumbers[completionCallNumber],
                  completedAtCall: completionCallNumber
                });
              }
            }
            break;
          case 'surroundingFree':
              if (winningPattern.surrPattern) {
                let surrNums = [
                  `I${surr[0]}`, `I${surr[1]}`, `G${surr[2]}`, `G${surr[3]}`
                ];
                const winningCalledNumbers = calledNumbers.filter(num => surrNums.includes(num));
                if (winningCalledNumbers.length === surrNums.length) {
                  const completionCallNumber = Math.max(...surrNums.map(num => 
                    calledNumbers.indexOf(num)
                  ));
                  allWinningPatterns.push({
                    pattern: 'surroundingFree',
                    numbers: surrNums,
                    lastCalledNumber: calledNumbers[completionCallNumber],
                    completedAtCall: completionCallNumber
                  });
                }
              }
              break;
          case 'diagonals':
                if (winningPattern.firstDiag) {
                  let diagNumbers = [
                    `B${diag1[0]}`, `I${diag1[1]}`, `G${diag1[2]}`, `O${diag1[3]}`
                  ];
                  const winningCalledNumbers = calledNumbers.filter(num => diagNumbers.includes(num));
                  if (winningCalledNumbers.length === diagNumbers.length) {
                    const completionCallNumber = Math.max(...diagNumbers.map(num => 
                      calledNumbers.indexOf(num)
                    ));
                    allWinningPatterns.push({
                      pattern: 'firstDiag',
                      numbers: diagNumbers,
                      lastCalledNumber: calledNumbers[completionCallNumber],
                      completedAtCall: completionCallNumber
                    });
                  }
                }
                if (winningPattern.secondDiag) {
                  let diagNumbers = [
                    `O${diag2[0]}`, `G${diag2[1]}`, `I${diag2[2]}`, `B${diag2[3]}`
                  ];
                  const winningCalledNumbers = calledNumbers.filter(num => diagNumbers.includes(num));
                  if (winningCalledNumbers.length === diagNumbers.length) {
                    const completionCallNumber = Math.max(...diagNumbers.map(num => 
                      calledNumbers.indexOf(num)
                    ));
                    allWinningPatterns.push({
                      pattern: 'secondDiag',
                      numbers: diagNumbers,
                      lastCalledNumber: calledNumbers[completionCallNumber],
                      completedAtCall: completionCallNumber
                    });
                  }
                }
                break;
          case 'columns':
            if (winningPattern.Bcolumn) {
              let colNumbers = [];
              B.forEach(num => colNumbers.push(`B${num}`));
              const winningCalledNumbers = calledNumbers.filter(num => colNumbers.includes(num));
              if (winningCalledNumbers.length === colNumbers.length) {
                const completionCallNumber = Math.max(...colNumbers.map(num => 
                  calledNumbers.indexOf(num)
                ));
                allWinningPatterns.push({
                  pattern: 'Bcolumn',
                  numbers: colNumbers,
                  lastCalledNumber: calledNumbers[completionCallNumber],
                  completedAtCall: completionCallNumber
                });
              }
            }
            if (winningPattern.Icolumn) {
              let colNumbers = [];
              I.forEach(num => colNumbers.push(`I${num}`));
              const winningCalledNumbers = calledNumbers.filter(num => colNumbers.includes(num));
              if (winningCalledNumbers.length === colNumbers.length) {
                const completionCallNumber = Math.max(...colNumbers.map(num => 
                  calledNumbers.indexOf(num)
                ));
                allWinningPatterns.push({
                  pattern: 'Icolumn',
                  numbers: colNumbers,
                  lastCalledNumber: calledNumbers[completionCallNumber],
                  completedAtCall: completionCallNumber
                });
              }
            }
            if (winningPattern.Ncolumn) {
              let colNumbers = [];
              N.forEach(num => { if (num !== 'FREE') colNumbers.push(`N${num}`); });
              const winningCalledNumbers = calledNumbers.filter(num => colNumbers.includes(num));
              if (winningCalledNumbers.length === colNumbers.length) {
                const completionCallNumber = Math.max(...colNumbers.map(num => 
                  calledNumbers.indexOf(num)
                ));
                allWinningPatterns.push({
                  pattern: 'Ncolumn',
                  numbers: colNumbers,
                  lastCalledNumber: calledNumbers[completionCallNumber],
                  completedAtCall: completionCallNumber
                });
              }
            }
            if (winningPattern.Gcolumn) {
              let colNumbers = [];
              G.forEach(num => colNumbers.push(`G${num}`));
              const winningCalledNumbers = calledNumbers.filter(num => colNumbers.includes(num));
              if (winningCalledNumbers.length === colNumbers.length) {
                const completionCallNumber = Math.max(...colNumbers.map(num => 
                  calledNumbers.indexOf(num)
                ));
                allWinningPatterns.push({
                  pattern: 'Gcolumn',
                  numbers: colNumbers,
                  lastCalledNumber: calledNumbers[completionCallNumber],
                  completedAtCall: completionCallNumber
                });
              }
            }
            if (winningPattern.Ocolumn) {
              let colNumbers = [];
              O.forEach(num => colNumbers.push(`O${num}`));
              const winningCalledNumbers = calledNumbers.filter(num => colNumbers.includes(num));
              if (winningCalledNumbers.length === colNumbers.length) {
                const completionCallNumber = Math.max(...colNumbers.map(num => 
                  calledNumbers.indexOf(num)
                ));
                allWinningPatterns.push({
                  pattern: 'Ocolumn',
                  numbers: colNumbers,
                  lastCalledNumber: calledNumbers[completionCallNumber],
                  completedAtCall: completionCallNumber
                });
              }
            }
            break;       
          case 'rows':
              if (winningPattern.firstRow) {
                let rowNumbers = [
                  `B${row1[0]}`, `I${row1[1]}`, `N${row1[2]}`, `G${row1[3]}`, `O${row1[4]}`
                ];
                const winningCalledNumbers = calledNumbers.filter(num => rowNumbers.includes(num));
                if (winningCalledNumbers.length === rowNumbers.length) {
                  const completionCallNumber = Math.max(...rowNumbers.map(num => 
                    calledNumbers.indexOf(num)
                  ));
                  allWinningPatterns.push({
                    pattern: 'firstRow',
                    numbers: rowNumbers,
                    lastCalledNumber: calledNumbers[completionCallNumber],
                    completedAtCall: completionCallNumber
                  });
                }
              }
              if (winningPattern.secondRow) {
                let rowNumbers = [
                  `B${row2[0]}`, `I${row2[1]}`, `N${row2[2]}`, `G${row2[3]}`, `O${row2[4]}`
                ];
                const winningCalledNumbers = calledNumbers.filter(num => rowNumbers.includes(num));
                if (winningCalledNumbers.length === rowNumbers.length) {
                  const completionCallNumber = Math.max(...rowNumbers.map(num => 
                    calledNumbers.indexOf(num)
                  ));
                  allWinningPatterns.push({
                    pattern: 'secondRow',
                    numbers: rowNumbers,
                    lastCalledNumber: calledNumbers[completionCallNumber],
                    completedAtCall: completionCallNumber
                  });
                }
              }
              if (winningPattern.thirdRow) {
                let rowNumbers = [
                  `B${row3[0]}`, `I${row3[1]}`, `G${row3[2]}`, `O${row3[3]}`
                ];
                const winningCalledNumbers = calledNumbers.filter(num => rowNumbers.includes(num));
                if (winningCalledNumbers.length === rowNumbers.length) {
                  const completionCallNumber = Math.max(...rowNumbers.map(num => 
                    calledNumbers.indexOf(num)
                  ));
                  allWinningPatterns.push({
                    pattern: 'thirdRow',
                    numbers: rowNumbers,
                    lastCalledNumber: calledNumbers[completionCallNumber],
                    completedAtCall: completionCallNumber
                  });
                }
              }
              if (winningPattern.fourthRow) {
                let rowNumbers = [
                  `B${row4[0]}`, `I${row4[1]}`, `N${row4[2]}`, `G${row4[3]}`, `O${row4[4]}`
                ];
                const winningCalledNumbers = calledNumbers.filter(num => rowNumbers.includes(num));
                if (winningCalledNumbers.length === rowNumbers.length) {
                  const completionCallNumber = Math.max(...rowNumbers.map(num => 
                    calledNumbers.indexOf(num)
                  ));
                  allWinningPatterns.push({
                    pattern: 'fourthRow',
                    numbers: rowNumbers,
                    lastCalledNumber: calledNumbers[completionCallNumber],
                    completedAtCall: completionCallNumber
                  });
                }
              }
              if (winningPattern.fifthRow) {
                let rowNumbers = [
                  `B${row5[0]}`, `I${row5[1]}`, `N${row5[2]}`, `G${row5[3]}`, `O${row5[4]}`
                ];
                const winningCalledNumbers = calledNumbers.filter(num => rowNumbers.includes(num));
                if (winningCalledNumbers.length === rowNumbers.length) {
                  const completionCallNumber = Math.max(...rowNumbers.map(num => 
                    calledNumbers.indexOf(num)
                  ));
                  allWinningPatterns.push({
                    pattern: 'fifthRow',
                    numbers: rowNumbers,
                    lastCalledNumber: calledNumbers[completionCallNumber],
                    completedAtCall: completionCallNumber
                  });
                }
              }
              break;      
          case 'cross':
                if (winningPattern.crossPattern) {
                  let crossNumbers = [];
                  N.forEach(num => { if (num !== 'FREE') crossNumbers.push(`N${num}`); });
                  crossNumbers.push(
                    `B${row3[0]}`, `I${row3[1]}`, `G${row3[2]}`, `O${row3[3]}`
                  );
                  const winningCalledNumbers = calledNumbers.filter(num => crossNumbers.includes(num));
                  if (winningCalledNumbers.length === crossNumbers.length) {
                    const completionCallNumber = Math.max(...crossNumbers.map(num => 
                      calledNumbers.indexOf(num)
                    ));
                    allWinningPatterns.push({
                      pattern: 'cross',
                      numbers: crossNumbers,
                      lastCalledNumber: calledNumbers[completionCallNumber],
                      completedAtCall: completionCallNumber
                    });
                  }
                }
                break;           
          case 'diamond':
                  if (winningPattern.diamondPattern) {
                    let diamondNumbers = [
                      `B${B[2]}`, `I${I[1]}`, `I${I[3]}`,
                      `N${N[0]}`, `N${N[4]}`,
                      `G${G[1]}`, `G${G[3]}`, `O${O[2]}`
                    ];
                    const winningCalledNumbers = calledNumbers.filter(num => diamondNumbers.includes(num));
                    if (winningCalledNumbers.length === diamondNumbers.length) {
                      const completionCallNumber = Math.max(...diamondNumbers.map(num => 
                        calledNumbers.indexOf(num)
                      ));
                      allWinningPatterns.push({
                        pattern: 'diamond',
                        numbers: diamondNumbers,
                        lastCalledNumber: calledNumbers[completionCallNumber],
                        completedAtCall: completionCallNumber
                      });
                    }
                  }
                  break;
          case 'outerSquare':
                    if (winningPattern.outerSquarePattern) {
                      let squareNumbers = [
                        `B${B[0]}`, `I${I[0]}`, `N${N[0]}`, `G${G[0]}`, `O${O[0]}`,
                        `B${B[4]}`, `I${I[4]}`, `N${N[4]}`, `G${G[4]}`, `O${O[4]}`,
                        `B${B[1]}`, `B${B[2]}`, `B${B[3]}`,
                        `O${O[1]}`, `O${O[2]}`, `O${O[3]}`
                      ];
                      const winningCalledNumbers = calledNumbers.filter(num => squareNumbers.includes(num));
                      if (winningCalledNumbers.length === squareNumbers.length) {
                        const completionCallNumber = Math.max(...squareNumbers.map(num => 
                          calledNumbers.indexOf(num)
                        ));
                        allWinningPatterns.push({
                          pattern: 'outerSquare',
                          numbers: squareNumbers,
                          lastCalledNumber: calledNumbers[completionCallNumber],
                          completedAtCall: completionCallNumber
                        });
                      }
                    }
                    break;
          
          case 'zPattern':
            if (winningPattern.zPatternShape) {
              let zNumbers = [
                `B${B[0]}`, `I${I[0]}`, `N${N[0]}`, `G${G[0]}`, `O${O[0]}`,
                `G${G[1]}`, `I${I[3]}`,
                `B${B[4]}`, `I${I[4]}`, `N${N[4]}`, `G${G[4]}`, `O${O[4]}`
              ];
              const winningCalledNumbers = calledNumbers.filter(num => zNumbers.includes(num));
              if (winningCalledNumbers.length === zNumbers.length) {
                const completionCallNumber = Math.max(...zNumbers.map(num => 
                  calledNumbers.indexOf(num)
                ));
                allWinningPatterns.push({
                  pattern: 'zPattern',
                  numbers: zNumbers,
                  lastCalledNumber: calledNumbers[completionCallNumber],
                  completedAtCall: completionCallNumber
                });
              }
            }
            break;
        
          case 'fullCard':
            if (winningPattern.fullCardPattern) {
              let cardNumbers = [];
              B.forEach(num => cardNumbers.push(`B${num}`));
              I.forEach(num => cardNumbers.push(`I${num}`));
              N.forEach(num => { if (num !== 'FREE') cardNumbers.push(`N${num}`); });
              G.forEach(num => cardNumbers.push(`G${num}`));
              O.forEach(num => cardNumbers.push(`O${num}`));
              const winningCalledNumbers = calledNumbers.filter(num => cardNumbers.includes(num));
              if (winningCalledNumbers.length === cardNumbers.length) {
                const completionCallNumber = Math.max(...cardNumbers.map(num => 
                  calledNumbers.indexOf(num)
                ));
                allWinningPatterns.push({
                  pattern: 'fullCard',
                  numbers: cardNumbers,
                  lastCalledNumber: calledNumbers[completionCallNumber],
                  completedAtCall: completionCallNumber
                });
              }
            }
            break;
        
          case 'lShape':
            if (winningPattern.lShapePattern) {
              let lNumbers = [];
              B.forEach(num => lNumbers.push(`B${num}`));
              lNumbers.push(
                `I${row5[1]}`, `N${row5[2]}`, `G${row5[3]}`, `O${row5[4]}`
              );
              const winningCalledNumbers = calledNumbers.filter(num => lNumbers.includes(num));
              if (winningCalledNumbers.length === lNumbers.length) {
                const completionCallNumber = Math.max(...lNumbers.map(num => 
                  calledNumbers.indexOf(num)
                ));
                allWinningPatterns.push({
                  pattern: 'lShape',
                  numbers: lNumbers,
                  lastCalledNumber: calledNumbers[completionCallNumber],
                  completedAtCall: completionCallNumber
                });
              }
            }
            break;
        
          case 'bothDiagonals':
            if (winningPattern.bothDiagonalsPattern) {
              let bothDiagNumbers = [
                `B${diag1[0]}`, `I${diag1[1]}`, `G${diag1[2]}`, `O${diag1[3]}`,
                `O${diag2[0]}`, `G${diag2[1]}`, `I${diag2[2]}`, `B${diag2[3]}`
              ];
              const winningCalledNumbers = calledNumbers.filter(num => bothDiagNumbers.includes(num));
              if (winningCalledNumbers.length === bothDiagNumbers.length) {
                const completionCallNumber = Math.max(...bothDiagNumbers.map(num => 
                  calledNumbers.indexOf(num)
                ));
                allWinningPatterns.push({
                  pattern: 'bothDiagonals',
                  numbers: bothDiagNumbers,
                  lastCalledNumber: calledNumbers[completionCallNumber],
                  completedAtCall: completionCallNumber
                });
              }
            }
            break;
          
          case 'tShape':
              if (winningPattern.tShapePattern) {
                let tNumbers = [
                  `B${row1[0]}`, `I${row1[1]}`, `N${row1[2]}`, `G${row1[3]}`, `O${row1[4]}`
                ];
                N.forEach(num => { if (num !== 'FREE') tNumbers.push(`N${num}`); });
                const winningCalledNumbers = calledNumbers.filter(num => tNumbers.includes(num));
                if (winningCalledNumbers.length === tNumbers.length) {
                  const completionCallNumber = Math.max(...tNumbers.map(num => 
                    calledNumbers.indexOf(num)
                  ));
                  allWinningPatterns.push({
                    pattern: 'tShape',
                    numbers: tNumbers,
                    lastCalledNumber: calledNumbers[completionCallNumber],
                    completedAtCall: completionCallNumber
                  });
                }
              }
              break;
          
          case 'sevenShape':
              if (winningPattern.sevenShapePattern) {
                let sevenNumbers = [
                  `B${row1[0]}`, `I${row1[1]}`, `N${row1[2]}`, `G${row1[3]}`, `O${row1[4]}`,
                  `O${row1[4]}`, `G${row2[3]}`, `N${row3[2]}`, `I${row4[1]}`, `B${row5[0]}`
                ];
                const winningCalledNumbers = calledNumbers.filter(num => sevenNumbers.includes(num));
                if (winningCalledNumbers.length === sevenNumbers.length) {
                  const completionCallNumber = Math.max(...sevenNumbers.map(num => 
                    calledNumbers.indexOf(num)
                  ));
                  allWinningPatterns.push({
                    pattern: 'sevenShape',
                    numbers: sevenNumbers,
                    lastCalledNumber: calledNumbers[completionCallNumber],
                    completedAtCall: completionCallNumber
                  });
                }
              }
              break;
          
          case 'innerSquare':
              if (winningPattern.innerSquarePattern) {
                let innerNumbers = [
                  `I${I[1]}`, `I${I[2]}`, `I${I[3]}`,
                  `N${N[1]}`, `N${N[3]}`,
                  `G${G[1]}`, `G${G[2]}`, `G${G[3]}`
                ];
                const winningCalledNumbers = calledNumbers.filter(num => innerNumbers.includes(num));
                if (winningCalledNumbers.length === innerNumbers.length) {
                  const completionCallNumber = Math.max(...innerNumbers.map(num => 
                    calledNumbers.indexOf(num)
                  ));
                  allWinningPatterns.push({
                    pattern: 'innerSquare',
                    numbers: innerNumbers,
                    lastCalledNumber: calledNumbers[completionCallNumber],
                    completedAtCall: completionCallNumber
                  });
                }
              }
              break;
          
          case 'cPattern':
              if (winningPattern.cPatternShape) {
                let cNumbers = [];
                B.forEach(num => cNumbers.push(`B${num}`));
                cNumbers.push(
                  `I${row1[1]}`, `N${row1[2]}`, `G${row1[3]}`, `O${row1[4]}`,
                  `I${row5[1]}`, `N${row5[2]}`, `G${row5[3]}`, `O${row5[4]}`
                );
                const winningCalledNumbers = calledNumbers.filter(num => cNumbers.includes(num));
                if (winningCalledNumbers.length === cNumbers.length) {
                  const completionCallNumber = Math.max(...cNumbers.map(num => 
                    calledNumbers.indexOf(num)
                  ));
                  allWinningPatterns.push({
                    pattern: 'cPattern',
                    numbers: cNumbers,
                    lastCalledNumber: calledNumbers[completionCallNumber],
                    completedAtCall: completionCallNumber
                  });
                }
              }
              break;
          
          case 'numberFour':
            if (winningPattern.numberFourPattern) {
              let fourNumbers = [];
              N.forEach(num => { if (num !== 'FREE') fourNumbers.push(`N${num}`); });
              fourNumbers.push(
                `B${B[2]}`, `I${I[2]}`, `G${G[2]}`, `O${O[2]}`
              );
              const winningCalledNumbers = calledNumbers.filter(num => fourNumbers.includes(num));
              if (winningCalledNumbers.length === fourNumbers.length) {
                const completionCallNumber = Math.max(...fourNumbers.map(num => 
                  calledNumbers.indexOf(num)
                ));
                allWinningPatterns.push({
                  pattern: 'numberFour',
                  numbers: fourNumbers,
                  lastCalledNumber: calledNumbers[completionCallNumber],
                  completedAtCall: completionCallNumber
                });
              }
            }
            break;
        
          case 'hShape':
              if (winningPattern.hShapePattern) {
                let hNumbers = [];
                B.forEach(num => hNumbers.push(`B${num}`));
                O.forEach(num => hNumbers.push(`O${num}`));
                hNumbers.push(
                  `I${I[2]}`, `N${N[2]}`, `G${G[2]}`
                );
                const winningCalledNumbers = calledNumbers.filter(num => hNumbers.includes(num));
                if (winningCalledNumbers.length === hNumbers.length) {
                  const completionCallNumber = Math.max(...hNumbers.map(num => 
                    calledNumbers.indexOf(num)
                  ));
                  allWinningPatterns.push({
                    pattern: 'hShape',
                    numbers: hNumbers,
                    lastCalledNumber: calledNumbers[completionCallNumber],
                    completedAtCall: completionCallNumber
                  });
                }
              }
              break;

        }

        if (patternNumbers.length > 0) {
          const winningCalledNumbers = calledNumbers.filter(num => patternNumbers.includes(num));
          if (winningCalledNumbers.length === patternNumbers.length) {  // Pattern is complete
            // Find the earliest call number that completed this pattern
            const completionCallNumber = Math.max(...patternNumbers.map(num => 
              calledNumbers.indexOf(num)
            ));
            
            allWinningPatterns.push({
              pattern: patternType,
              numbers: patternNumbers,
              lastCalledNumber: calledNumbers[completionCallNumber],
              completedAtCall: completionCallNumber
            });
          }
        }
      }

      if (allWinningPatterns.length > 0) {   
        const firstCompletedPattern = allWinningPatterns.reduce((earliest, current) => {
          if (current.completedAtCall < earliest.completedAtCall) {
            return current;
          }
          return earliest;
        }, allWinningPatterns[0]);
        
        setLastWinningNumber(firstCompletedPattern.lastCalledNumber);
      }
    }
  }, [isWinner, winningNumbers, calledNumbers, B, I, N, G, O, row1, row2, row3, row4, row5, diag1, diag2, corner, surr]);
  
  const checkWinningPattern = () => {
    let cornerPattern = false;
    let surrPattern = false;
    let firstDiag = false;
    let secondDiag = false;
    let Bcolumn = false;
    let Icolumn = false;
    let Ncolumn = false;
    let Gcolumn = false;
    let Ocolumn = false;
    let firstRow = false;
    let secondRow = false;
    let thirdRow = false;
    let fourthRow = false;
    let fifthRow = false;
    let fullCardPattern = false;
    let lShapePattern = false;
    let bothDiagonalsPattern = false;
    let tShapePattern = false;
    let sevenShapePattern = false;
    let innerSquarePattern = false;
    let diamondPattern = false;
    let cPatternShape = false;
    let numberFourPattern = false;
    let hShapePattern = false;
    let crossPattern = false;
    let outerSquarePattern = false;
    let zPatternShape = false;

    for (const patternType of winningPatterns) {
      switch(patternType) {
        case 'any':
        cornerPattern = calledNumbers.includes(`B${corner[0]}`) && 
                      calledNumbers.includes(`B${corner[1]}`) && 
                      calledNumbers.includes(`O${corner[2]}`) && 
                      calledNumbers.includes(`O${corner[3]}`);
                      
        surrPattern = calledNumbers.includes(`I${surr[0]}`) && 
                    calledNumbers.includes(`I${surr[1]}`) && 
                    calledNumbers.includes(`G${surr[2]}`) && 
                    calledNumbers.includes(`G${surr[3]}`);

        firstDiag = calledNumbers.includes(`B${diag1[0]}`) && 
                  calledNumbers.includes(`I${diag1[1]}`) && 
                  calledNumbers.includes(`G${diag1[2]}`) && 
                  calledNumbers.includes(`O${diag1[3]}`);

        secondDiag = calledNumbers.includes(`O${diag2[0]}`) && 
                    calledNumbers.includes(`G${diag2[1]}`) && 
                    calledNumbers.includes(`I${diag2[2]}`) && 
                    calledNumbers.includes(`B${diag2[3]}`);

        Bcolumn = B.every((num) => calledNumbers.includes(`B${num}`)) && calledNumbers.length !== 0;
        Icolumn = I.every((num) => calledNumbers.includes(`I${num}`)) && calledNumbers.length !== 0;
        Ncolumn = N.every((num) => calledNumbers.includes(`N${num}`)) && calledNumbers.length !== 0;
        Gcolumn = G.every((num) => calledNumbers.includes(`G${num}`)) && calledNumbers.length !== 0;
        Ocolumn = O.every((num) => calledNumbers.includes(`O${num}`)) && calledNumbers.length !== 0;

        firstRow = calledNumbers.includes(`B${row1[0]}`) && calledNumbers.includes(`I${row1[1]}`) && calledNumbers.includes(`N${row1[2]}`) && calledNumbers.includes(`G${row1[3]}`) && calledNumbers.includes(`O${row1[4]}`);
        secondRow = calledNumbers.includes(`B${row2[0]}`) && calledNumbers.includes(`I${row2[1]}`) && calledNumbers.includes(`N${row2[2]}`) && calledNumbers.includes(`G${row2[3]}`) && calledNumbers.includes(`O${row2[4]}`);
        thirdRow = calledNumbers.includes(`B${row3[0]}`) && calledNumbers.includes(`I${row3[1]}`) && calledNumbers.includes(`G${row3[2]}`) && calledNumbers.includes(`O${row3[3]}`);
        fourthRow = calledNumbers.includes(`B${row4[0]}`) && calledNumbers.includes(`I${row4[1]}`) && calledNumbers.includes(`N${row4[2]}`) && calledNumbers.includes(`G${row4[3]}`) && calledNumbers.includes(`O${row4[4]}`);
        fifthRow = calledNumbers.includes(`B${row5[0]}`) && calledNumbers.includes(`I${row5[1]}`) && calledNumbers.includes(`N${row5[2]}`) && calledNumbers.includes(`G${row5[3]}`) && calledNumbers.includes(`O${row5[4]}`);
        break;

        case 'corners':
          cornerPattern = calledNumbers.includes(`B${corner[0]}`) && 
                        calledNumbers.includes(`B${corner[1]}`) && 
                        calledNumbers.includes(`O${corner[2]}`) && 
                        calledNumbers.includes(`O${corner[3]}`);
          break;
        case 'surroundingFree':
          surrPattern = calledNumbers.includes(`I${surr[0]}`) && 
                      calledNumbers.includes(`I${surr[1]}`) && 
                      calledNumbers.includes(`G${surr[2]}`) && 
                      calledNumbers.includes(`G${surr[3]}`);
          break;
        case 'diagonals':
          firstDiag = calledNumbers.includes(`B${diag1[0]}`) && 
                    calledNumbers.includes(`I${diag1[1]}`) && 
                    calledNumbers.includes(`G${diag1[2]}`) && 
                    calledNumbers.includes(`O${diag1[3]}`);
          secondDiag = calledNumbers.includes(`O${diag2[0]}`) && 
                      calledNumbers.includes(`G${diag2[1]}`) && 
                      calledNumbers.includes(`I${diag2[2]}`) && 
                      calledNumbers.includes(`B${diag2[3]}`);
          break;
          case 'columns':
            Bcolumn = B.every((num) => calledNumbers.includes(`B${num}`));
            Icolumn = I.every((num) => calledNumbers.includes(`I${num}`));
            Ncolumn = N.every((num) => num === 'FREE' || calledNumbers.includes(`N${num}`));
            Gcolumn = G.every((num) => calledNumbers.includes(`G${num}`));
            Ocolumn = O.every((num) => calledNumbers.includes(`O${num}`));
            break;
          case 'rows':
            firstRow = calledNumbers.includes(`B${row1[0]}`) && calledNumbers.includes(`I${row1[1]}`) && calledNumbers.includes(`N${row1[2]}`) && calledNumbers.includes(`G${row1[3]}`) && calledNumbers.includes(`O${row1[4]}`);
            secondRow = calledNumbers.includes(`B${row2[0]}`) && calledNumbers.includes(`I${row2[1]}`) && calledNumbers.includes(`N${row2[2]}`) && calledNumbers.includes(`G${row2[3]}`) && calledNumbers.includes(`O${row2[4]}`);
            thirdRow = calledNumbers.includes(`B${row3[0]}`) && calledNumbers.includes(`I${row3[1]}`) && calledNumbers.includes(`G${row3[2]}`) && calledNumbers.includes(`O${row3[3]}`);
            fourthRow = calledNumbers.includes(`B${row4[0]}`) && calledNumbers.includes(`I${row4[1]}`) && calledNumbers.includes(`N${row4[2]}`) && calledNumbers.includes(`G${row4[3]}`) && calledNumbers.includes(`O${row4[4]}`);
            fifthRow = calledNumbers.includes(`B${row5[0]}`) && calledNumbers.includes(`I${row5[1]}`) && calledNumbers.includes(`N${row5[2]}`) && calledNumbers.includes(`G${row5[3]}`) && calledNumbers.includes(`O${row5[4]}`);
            break;

          case 'fullCard':
            fullCardPattern = B.every((num) => calledNumbers.includes(`B${num}`)) &&
                              I.every((num) => calledNumbers.includes(`I${num}`)) &&
                              N.every((num) => num === 'FREE' || calledNumbers.includes(`N${num}`)) &&
                              G.every((num) => calledNumbers.includes(`G${num}`)) &&
                              O.every((num) => calledNumbers.includes(`O${num}`));
            break;
      
          case 'lShape':
            const leftVertical = B.every((num) => calledNumbers.includes(`B${num}`));
            const bottomRow = calledNumbers.includes(`I${row5[1]}`) && 
                              calledNumbers.includes(`N${row5[2]}`) && 
                              calledNumbers.includes(`G${row5[3]}`) && 
                              calledNumbers.includes(`O${row5[4]}`);
            lShapePattern = leftVertical && bottomRow;
            break;
      
          case 'bothDiagonals':
            firstDiag = calledNumbers.includes(`B${diag1[0]}`) && 
                        calledNumbers.includes(`I${diag1[1]}`) && 
                        calledNumbers.includes(`G${diag1[2]}`) && 
                        calledNumbers.includes(`O${diag1[3]}`);
            secondDiag = calledNumbers.includes(`O${diag2[0]}`) && 
                        calledNumbers.includes(`G${diag2[1]}`) && 
                        calledNumbers.includes(`I${diag2[2]}`) && 
                        calledNumbers.includes(`B${diag2[3]}`);
            bothDiagonalsPattern = firstDiag && secondDiag;
            break;
          
          case 'tShape':
            const topRow = calledNumbers.includes(`B${row1[0]}`) && 
                          calledNumbers.includes(`I${row1[1]}`) && 
                          calledNumbers.includes(`N${row1[2]}`) && 
                          calledNumbers.includes(`G${row1[3]}`) && 
                          calledNumbers.includes(`O${row1[4]}`);
            const middleVertical = N.every((num) => num === 'FREE' || calledNumbers.includes(`N${num}`));
            tShapePattern = topRow && middleVertical;
            break;
      
          case 'sevenShape':
            const topRowSeven = calledNumbers.includes(`B${row1[0]}`) && 
                                calledNumbers.includes(`I${row1[1]}`) && 
                                calledNumbers.includes(`N${row1[2]}`) && 
                                calledNumbers.includes(`G${row1[3]}`) && 
                                calledNumbers.includes(`O${row1[4]}`);
            const secondaryDiagonal = calledNumbers.includes(`O${row1[4]}`) && 
                                      calledNumbers.includes(`G${row2[3]}`) && 
                                      calledNumbers.includes(`N${row3[2]}`) && 
                                      calledNumbers.includes(`I${row4[1]}`) && 
                                      calledNumbers.includes(`B${row5[0]}`);
            sevenShapePattern = topRowSeven && secondaryDiagonal;
            break;

          case 'innerSquare':
            innerSquarePattern = calledNumbers.includes(`I${I[1]}`) && 
                                calledNumbers.includes(`I${I[2]}`) && 
                                calledNumbers.includes(`I${I[3]}`) && 
                                calledNumbers.includes(`N${N[1]}`) && 
                                (N[2] === 'FREE' || calledNumbers.includes(`N${N[2]}`)) && 
                                calledNumbers.includes(`N${N[3]}`) && 
                                calledNumbers.includes(`G${G[1]}`) && 
                                calledNumbers.includes(`G${G[2]}`) && 
                                calledNumbers.includes(`G${G[3]}`);
            break;
      
          case 'diamond':
            diamondPattern = calledNumbers.includes(`B${B[2]}`) && // Middle of B
                            calledNumbers.includes(`I${I[1]}`) && // Upper middle I
                            calledNumbers.includes(`I${I[3]}`) && // Lower middle I
                            calledNumbers.includes(`N${N[0]}`) && // Top N
                            calledNumbers.includes(`N${N[4]}`) && // Bottom N
                            calledNumbers.includes(`G${G[1]}`) && // Upper middle G
                            calledNumbers.includes(`G${G[3]}`) && // Lower middle G
                            calledNumbers.includes(`O${O[2]}`);   // Middle of O
            break;
          
            case 'cPattern':
              cPatternShape = B.every((num) => calledNumbers.includes(`B${num}`)) && // Entire B column
                              calledNumbers.includes(`I${row1[1]}`) && // Top row
                              calledNumbers.includes(`N${row1[2]}`) && 
                              calledNumbers.includes(`G${row1[3]}`) && 
                              calledNumbers.includes(`O${row1[4]}`) &&
                              calledNumbers.includes(`I${row5[1]}`) && // Bottom row
                              calledNumbers.includes(`N${row5[2]}`) && 
                              calledNumbers.includes(`G${row5[3]}`) && 
                              calledNumbers.includes(`O${row5[4]}`);
              break;
      
          case 'numberFour':
            const verticalFour = N.every((num) => num === 'FREE' || calledNumbers.includes(`N${num}`));
            const horizontalFour = calledNumbers.includes(`I${I[1]}`) && 
                                  calledNumbers.includes(`I${I[2]}`) && 
                                  calledNumbers.includes(`B${B[2]}`) && 
                                  calledNumbers.includes(`G${G[2]}`) && 
                                  calledNumbers.includes(`O${O[2]}`);
            numberFourPattern = verticalFour && horizontalFour;
            break;
          
          case 'hShape':
            const leftVerticalH = B.every((num) => calledNumbers.includes(`B${num}`)); // Entire B column
            const rightVerticalH = O.every((num) => calledNumbers.includes(`O${num}`)); // Entire O column
            const middleRowH = calledNumbers.includes(`I${I[2]}`) && // Middle row (index 2)
                                (N[2] === 'FREE' || calledNumbers.includes(`N${N[2]}`)) && 
                                calledNumbers.includes(`G${G[2]}`);
            hShapePattern = leftVerticalH && rightVerticalH && middleRowH;
            break;
      
            case 'cross':
              const verticalCross = N.every((num) => num === 'FREE' || calledNumbers.includes(`N${num}`));
              const horizontalCross = calledNumbers.includes(`B${row3[0]}`) && 
                                    calledNumbers.includes(`I${row3[1]}`) && 
                                    calledNumbers.includes(`G${row3[2]}`) && 
                                    calledNumbers.includes(`O${row3[3]}`);
              crossPattern = verticalCross && horizontalCross;
              break;

          case 'outerSquare':
            // Top row
            const topRowSquare = calledNumbers.includes(`B${B[0]}`) && 
                                calledNumbers.includes(`I${I[0]}`) && 
                                calledNumbers.includes(`N${N[0]}`) && 
                                calledNumbers.includes(`G${G[0]}`) && 
                                calledNumbers.includes(`O${O[0]}`);
            
            // Bottom row
            const bottomRowSquare = calledNumbers.includes(`B${B[4]}`) && 
                                    calledNumbers.includes(`I${I[4]}`) && 
                                    calledNumbers.includes(`N${N[4]}`) && 
                                    calledNumbers.includes(`G${G[4]}`) && 
                                    calledNumbers.includes(`O${O[4]}`);
            
            // Left side (excluding corners)
            const leftSideSquare = calledNumbers.includes(`B${B[1]}`) && 
                                  calledNumbers.includes(`B${B[2]}`) && 
                                  calledNumbers.includes(`B${B[3]}`);
            
            // Right side (excluding corners)
            const rightSideSquare = calledNumbers.includes(`O${O[1]}`) && 
                                    calledNumbers.includes(`O${O[2]}`) && 
                                    calledNumbers.includes(`O${O[3]}`);
            
            outerSquarePattern = topRowSquare && bottomRowSquare && leftSideSquare && rightSideSquare;
          break;
      
          case 'zPattern':
            const topRowZ = calledNumbers.includes(`B${B[0]}`) && 
                            calledNumbers.includes(`I${I[0]}`) && 
                            calledNumbers.includes(`N${N[0]}`) && 
                            calledNumbers.includes(`G${G[0]}`) && 
                            calledNumbers.includes(`O${O[0]}`);
          
            const diagonalZ = calledNumbers.includes(`G${G[1]}`) && 
                              calledNumbers.includes(`I${I[3]}`);
          
            const bottomRowZ = calledNumbers.includes(`B${B[4]}`) && 
                                calledNumbers.includes(`I${I[4]}`) && 
                                calledNumbers.includes(`N${N[4]}`) && 
                                calledNumbers.includes(`G${G[4]}`) && 
                                calledNumbers.includes(`O${O[4]}`);
                                      
            zPatternShape = topRowZ && diagonalZ && bottomRowZ;
          
          break;
        }
    }
    
    return {
      Bcolumn,
      Icolumn,
      Ncolumn,
      Gcolumn,
      Ocolumn,
      firstRow,
      secondRow,
      thirdRow,
      fourthRow,
      fifthRow,
      firstDiag,
      secondDiag,
      cornerPattern,
      surrPattern,
      fullCardPattern,
      lShapePattern,
      bothDiagonalsPattern,
      tShapePattern,
      sevenShapePattern,
      innerSquarePattern,
      diamondPattern,
      cPatternShape,
      numberFourPattern,
      hShapePattern,
      crossPattern,
      outerSquarePattern,
      zPatternShape
    };
  };

  const winningPattern = checkWinningPattern();
  

  if (loading) {
    return <LoadingOverlay />
  }

  return (
    <div className="h-100">
        <h2 className={`text-center mb-4 ${isWinner ? 'text-success' : 'text-danger'} fw-bold`}>
          {cards.paletteNumber} {isWinner ? 'ዘግቷል' : 'አልዘጋም'}
          {isWinner ? `- (በ${lastWinningNumber})` : ''}
        </h2>

      <Row className="mx-auto"> 
        <Col xs={2} className="text-primary border p-0 text-center">
          <h1 className={`bg-primary text-white mb-0`}>B</h1>
          {cards.numbers.B.map((num, index) => (
            <div 
              className={`text-primary fw-bold border fs-1 ${
                
                (isWinner && calledNumbers.includes(`B${num}`) && winningPattern.Bcolumn ||
                  ((index === 0 && (winningPattern.firstRow || winningPattern.tShapePattern || winningPattern.sevenShapePattern || winningPattern.zPatternShape || winningPattern.cornerPattern )) ||
                  (index === 1 && winningPattern.secondRow) ||
                  (index === 2 && (winningPattern.thirdRow || winningPattern.diamondPattern || winningPattern.numberFourPattern || winningPattern.crossPattern)) ||
                  (index === 3 && winningPattern.fourthRow) ||
                  (index === 4 && (winningPattern.fifthRow)) ||
                  (index === 0 && winningPattern.firstDiag) ||
                  (index === 4 && (winningPattern.secondDiag || winningPattern.sevenShapePattern || winningPattern.zPatternShape || winningPattern.cornerPattern)) ||
                  ((index === 0 || index === 4) && winningPattern.cornerPattern) || winningPattern.fullCardPattern ||
                  winningPattern.lShapePattern || winningPattern.cPatternShape || winningPattern.hShapePattern || winningPattern.outerSquarePattern))
                  ? 'winning-cell'
                  : ''
              }
              ${
                calledNumbers.includes(`B${num}`) ? 'bg-green-300 text-white' : 'bg-white'
              }
              `}
              key={num}
            >
              {num}
            </div>
          ))}
        </Col>

        <Col xs={2} className="text-danger border p-0 text-center">
          <h1 className={`bg-danger text-white mb-0`}>I</h1>
          {cards.numbers.I.map((num, index) => (
            <div
              className={`text-primary fw-bold border fs-1 ${
                (isWinner && calledNumbers.includes(`I${num}`) && winningPattern.Icolumn ||
                  (index === 0 && (winningPattern.firstRow || winningPattern.tShapePattern || winningPattern.sevenShapePattern || winningPattern.cPatternShape || winningPattern.outerSquarePattern || winningPattern.zPatternShape)) ||
                  (index === 1 && (winningPattern.secondRow || winningPattern.firstDiag || winningPattern.surrPattern || winningPattern.innerSquarePattern || winningPattern.diamondPattern || winningPattern.numberFourPattern)) ||
                  (index === 2 && (winningPattern.thirdRow || winningPattern.innerSquarePattern || winningPattern.numberFourPattern || winningPattern.hShapePattern || winningPattern.crossPattern)) ||
                  (index === 3 && (winningPattern.fourthRow || winningPattern.secondDiag || winningPattern.surrPattern || winningPattern.sevenShapePattern || winningPattern.innerSquarePattern || winningPattern.diamondPattern || winningPattern.zPatternShape)) ||
                  (index === 4 && (winningPattern.fifthRow || winningPattern.lShapePattern || winningPattern.cPatternShape || winningPattern.outerSquarePattern || winningPattern.zPatternShape))
                  || winningPattern.fullCardPattern)
                  ? 'winning-cell'
                  : ''
              }
              ${
                calledNumbers.includes(`I${num}`) ? 'bg-green-300 text-white' : 'bg-white'
              } 
              `}
              key={num}
            >
              {num}
            </div>
          ))}
        </Col>

        <Col xs={3} className="text-warning border p-0 text-center">
          <h1 style={{ backgroundColor: 'orange' }} className={`text-white mb-0`}>
            N
          </h1>
          {cards.numbers.N.map((num, index) => (
            <div
              className={`text-primary fw-bold border fs-1  ${
                ((num === 'FREE' && isWinner) ? 'bg-green-500 winning-cell' : ''),
                (calledNumbers.includes(`N${num}`)) ||
                (num === 'FREE') ||
                (num === 'FREE' &&
                  (winningPattern.Ncolumn ||
                    (index === 0 && (winningPattern.firstRow || winningPattern.sevenShapePattern || winningPattern.outerSquarePattern )) ||
                    (index === 1 && (winningPattern.secondRow || winningPattern.innerSquarePattern)) ||
                    (index === 2 && (winningPattern.thirdRow || winningPattern.innerSquarePattern || winningPattern.zPatternShape)) ||
                    (index === 3 && (winningPattern.fourthRow || winningPattern.innerSquarePattern)) ||
                    (index === 4 && (winningPattern.fifthRow || winningPattern.lShapePattern || winningPattern.outerSquarePattern || winningPattern.zPatternShape)) ||
                    winningPattern.firstDiag ||
                    winningPattern.secondDiag || winningPattern.sevenShapePattern) || winningPattern.fullCardPattern || winningPattern.tShapePattern || winningPattern.numberFourPattern || winningPattern.crossPattern)
                  ? 'bg-green-300 text-white'
                  : 'bg-white'
                  // ,
                  // ((num === 'FREE' && isWinner) ? 'bg-green-500 text-white' : 'bg-white')
              }${
                (isWinner && calledNumbers.includes(`N${num}`)) && winningPattern.Ncolumn ||
                (index === 0 && (winningPattern.firstRow || winningPattern.sevenShapePattern || winningPattern.diamondPattern || winningPattern.cPatternShape || winningPattern.outerSquarePattern || winningPattern.zPatternShape)) ||
                (index === 1 && (winningPattern.secondRow || winningPattern.innerSquarePattern)) ||
                (index === 3 && (winningPattern.fourthRow || winningPattern.innerSquarePattern)) ||
                (index === 2 && (winningPattern.thirdRow || winningPattern.innerSquarePattern || winningPattern.numberFourPattern || winningPattern.hShapePattern || winningPattern.zPatternShape)) ||
                (index === 4 && (winningPattern.fifthRow || winningPattern.lShapePattern || winningPattern.diamondPattern || winningPattern.cPatternShape || winningPattern.outerSquarePattern || winningPattern.zPatternShape)) 
                || winningPattern.fullCardPattern || winningPattern.numberFourPattern || winningPattern.crossPattern
                  ? 'bg-green-500 winning-cell'
                  : ''
              }
              `}
              key={num}
            >
              {num === 'FREE' ? (
                <span className="fs-2">FREE</span>
              ) : (
                num
              )}
            </div>
          ))}
        </Col>

        <Col xs={2} className="text-success border p-0 text-center">
          <h1 className={`bg-success text-white mb-0`}>G</h1>
          {cards.numbers.G.map((num, index) => (
            <div
              className={`text-primary fw-bold border fs-1  ${
                (isWinner && calledNumbers.includes(`G${num}`) && winningPattern.Gcolumn ||
                  (index === 0 && (winningPattern.firstRow || winningPattern.tShapePattern || winningPattern.sevenShapePattern || winningPattern.cPatternShape || winningPattern.outerSquarePattern || winningPattern.zPatternShape)) ||
                  (index === 1 && (winningPattern.secondRow || winningPattern.secondDiag || winningPattern.surrPattern || winningPattern.sevenShapePattern || winningPattern.innerSquarePattern || winningPattern.diamondPattern || winningPattern.zPatternShape)) ||
                  (index === 2 && (winningPattern.thirdRow || winningPattern.innerSquarePattern || winningPattern.numberFourPattern || winningPattern.hShapePattern || winningPattern.crossPattern)) ||
                  (index === 3 && (winningPattern.fourthRow || winningPattern.firstDiag || winningPattern.surrPattern || winningPattern.innerSquarePattern || winningPattern.diamondPattern)) ||
                  (index === 4 && (winningPattern.fifthRow || winningPattern.lShapePattern || winningPattern.cPatternShape || winningPattern.outerSquarePattern || winningPattern.zPatternShape))
                  || winningPattern.fullCardPattern)
                  ? 'bg-green-500 winning-cell'
                  : ''
              }
              ${
                calledNumbers.includes(`G${num}`) ? 'bg-green-300 text-white' : 'bg-white'
              }`}
              key={num}
            >
              {num}
            </div>
          ))}
        </Col>

        <Col xs={2} className="text-info border p-0 text-center">
          <h1 className={`bg-warning text-white mb-0`}>O</h1>
          {cards.numbers.O.map((num, index) => (
            <div
              className={`text-primary fw-bold border fs-1  ${
                (isWinner && calledNumbers.includes(`O${num}`) && winningPattern.Ocolumn ||
                  (index === 0 && (winningPattern.firstRow || winningPattern.secondDiag || winningPattern.cornerPattern || winningPattern.tShapePattern || winningPattern.sevenShapePattern || winningPattern.cPatternShape || winningPattern.zPatternShape)) ||
                  (index === 1 && winningPattern.secondRow) ||
                  (index === 2 && (winningPattern.thirdRow || winningPattern.diamondPattern || winningPattern.numberFourPattern || winningPattern.crossPattern)) ||
                  (index === 3 && winningPattern.fourthRow) ||
                  (index === 4 && (winningPattern.fifthRow || winningPattern.lShapePattern || winningPattern.firstDiag || winningPattern.cornerPattern || winningPattern.cPatternShape || winningPattern.zPatternShape))  || winningPattern.fullCardPattern || winningPattern.hShapePattern || winningPattern.outerSquarePattern)
                  ? 'bg-green-500 winning-cell'
                  : ''
              }
              ${
                calledNumbers.includes(`O${num}`) ? 'bg-green-300 text-white' : 'bg-white'
              }
              `}
              key={num}
            >
              {num}
            </div>
          ))}
        </Col>
      </Row>
    </div>
  );
};

export default BingoCard;